module.exports = __webpack_public_path__ + "img/nt127-02-81-1.prt.27823103.jpg";